import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SeoHelmet({
  title,
  description,
  keywords,
  canonical,
  schemas,
  children,
  includeDefaultLocalBusinessSchema = true
}) {
  const metaTitle = title || 'Intense Infotech';
  const metaDescription = description || 'Intense Infotech digital services.';
  const metaKeywords = keywords || 'website development, web design, SEO';
  const hasCustomHeadChildren = React.Children.count(children) > 0;

  const defaultLocalBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Intense Infotech',
    url: 'https://www.intenseinfotech.com',
    telephone: '+91-XXXXXXXXXX',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '48 G, Mayur Vihar Phase 3',
      addressLocality: 'Delhi',
      addressRegion: 'Delhi',
      postalCode: '110096',
      addressCountry: 'IN'
    }
  };

  const defaultProfessionalServiceSchema = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Intense Infotech',
    offers: ['Web Development', 'React Development', 'WordPress', 'SEO']
  };

  const normalizedSchemas = Array.isArray(schemas)
    ? schemas.filter(Boolean)
    : schemas
      ? [schemas]
      : [];

  const schemaPayloads = [
    ...(includeDefaultLocalBusinessSchema
      ? [defaultLocalBusinessSchema, defaultProfessionalServiceSchema]
      : []),
    ...normalizedSchemas
  ];

  return (
    <Helmet>
      {!hasCustomHeadChildren && (
        <>
          <title>{metaTitle}</title>
          <meta name="description" content={metaDescription} />
          <meta name="keywords" content={metaKeywords} />
        </>
      )}
      {canonical && <link rel="canonical" href={canonical} />}
      {schemaPayloads.map((schema, idx) => (
        <script key={`schema-${idx}`} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
      {children}
    </Helmet>
  );
}
